var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSolarplant = function SvgSolarplant(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Ebene 1",
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.61 39.3V27.9a1 1 0 0 0-1-1H7a2 2 0 0 0-1.41.59L4 29.07a2 2 0 0 0-.58 1.42v11.39a1 1 0 0 0 1 1h19.51v2a.5.5 0 0 1-.5.5h-1.79a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h6.72a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1.93a.5.5 0 0 1-.5-.5v-2H43a2 2 0 0 0 1.41-.58L46 40.71a2 2 0 0 0 .61-1.41m-34.37-6v-3.9a.5.5 0 0 1 .5-.5h3.85a.51.51 0 0 1 .5.5v3.88a.51.51 0 0 1-.5.5h-3.85a.5.5 0 0 1-.5-.5zm4.85 3v4.1a.5.5 0 0 1-.5.5h-3.85a.5.5 0 0 1-.5-.5v-4.1a.5.5 0 0 1 .5-.5h3.85a.5.5 0 0 1 .5.48zm2.5-7.38h3.84a.5.5 0 0 1 .5.5v3.88a.5.5 0 0 1-.5.5h-3.84a.5.5 0 0 1-.5-.5v-3.9a.5.5 0 0 1 .5-.5zm6.84 0h3.85a.5.5 0 0 1 .5.5v3.88a.5.5 0 0 1-.5.5h-3.85a.51.51 0 0 1-.5-.5v-3.9a.51.51 0 0 1 .5-.5zm6.35 4.38v-3.9a.51.51 0 0 1 .5-.5h3.85a.5.5 0 0 1 .5.5v3.88a.5.5 0 0 1-.5.5h-3.85a.51.51 0 0 1-.5-.5zm4.85 3v4.1a.5.5 0 0 1-.5.5h-3.85a.5.5 0 0 1-.5-.5v-4.1a.5.5 0 0 1 .5-.5h3.85a.5.5 0 0 1 .5.48zm-6.85 0v4.1a.5.5 0 0 1-.5.5h-3.85a.5.5 0 0 1-.5-.5v-4.1a.5.5 0 0 1 .5-.5h3.85a.5.5 0 0 1 .5.48zm8.85 4.1v-4.1a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v3.6a1 1 0 0 1-1 1h-3.5a.5.5 0 0 1-.5-.52zm4.48-6.6h-4a.51.51 0 0 1-.5-.5v-3.9a.51.51 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v3.88a.5.5 0 0 1-.5.5zm-33.87-4.4v3.88a.51.51 0 0 1-.5.5H5.89a.5.5 0 0 1-.5-.5V29.9a1 1 0 0 1 1-1h3.35a.51.51 0 0 1 .5.5m-4.35 6.38h3.85a.5.5 0 0 1 .5.5v4.1a.5.5 0 0 1-.5.5H5.89a.5.5 0 0 1-.5-.5v-4.1a.5.5 0 0 1 .5-.5m13.2 4.6v-4.1a.5.5 0 0 1 .5-.5h3.84a.5.5 0 0 1 .5.5v4.1a.5.5 0 0 1-.5.5h-3.84a.5.5 0 0 1-.5-.5M25 18.71a5.44 5.44 0 1 0-5.43-5.43A5.44 5.44 0 0 0 25 18.71m0-8.87a3.44 3.44 0 1 1-3.43 3.44A3.44 3.44 0 0 1 25 9.84"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2.83,
    x: 24.12,
    y: 2.61,
    rx: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2.83,
    x: 24.12,
    y: 20.91,
    rx: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2.83,
    x: 17.65,
    y: 5.29,
    rx: 0.5,
    transform: "rotate(-45.01 18.643 6.706)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2.83,
    x: 30.59,
    y: 18.23,
    rx: 0.5,
    transform: "rotate(-45 31.588 19.646)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2.83,
    height: 2,
    x: 14.55,
    y: 12.17,
    rx: 0.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 2.83,
    height: 2,
    x: 32.85,
    y: 12.17,
    rx: 0.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 2.83,
    height: 2,
    x: 17.23,
    y: 18.64,
    rx: 0.5,
    transform: "rotate(-45 18.648 19.646)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 2.83,
    height: 2,
    x: 30.17,
    y: 5.7,
    rx: 0.5,
    transform: "rotate(-45 31.588 6.706)"
  })));
};
export default SvgSolarplant;